import Vue from 'vue'
import Vuex from 'vuex'


import WmsInventoryModule from './wms_inventory_module'
import WmsProductModule from './wms_product_module'
import WmsStorageModule from './wms_storage_module'
import WmsPartnerModule from './wms_partner_module'
import WmsPromotionModule from './wms_promotion_module'
import AuthModule from './auth_module'
import PlatformTiktokModule from './platform_tiktok_module'
import PlatformLazadaModule from './platform_lazada_module'
import PlatformShopeeModule from './platform_shopee_module'
import PlatformModule from './platform_module'

import OrderMoudle from './order_module'
import ProductMoudle from './product_module'
import ProductCategoryMoudle from './product_category_module'
import PackingModule from './packing_module'
import CustomerModule from './customer_module'
import ReportModule from './report_module'
import PaymentMethodMoudle from './payment_method_module'
import SaleChannelMoudle from './sale_channel_module'
import UserModule from './user_module'
import TeamModule from './team_module'
import DepartmentModule from './department_module'
import CouponModule from './coupon_module'
import MemberModule from './member_module'
import POModule from './po_module'
import PlatformStatementModule from './platform_statement_module'


import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)

const modules = {
    Auth: AuthModule,
    WmsInventory: WmsInventoryModule,
    WmsProduct: WmsProductModule,
    WmsStorage: WmsStorageModule,
    WmsPartner: WmsPartnerModule,
    WmsPromotion: WmsPromotionModule,
    Tiktok: PlatformTiktokModule,
    Shopee: PlatformShopeeModule,
    Lazada: PlatformLazadaModule,
	Platform: PlatformModule,

	Order: OrderMoudle,
	Product: ProductMoudle,
	ProductCategory: ProductCategoryMoudle,
	SaleChannel: SaleChannelMoudle,
	PaymentMethod: PaymentMethodMoudle,
	Packing: PackingModule,
	Customer: CustomerModule,
	Report: ReportModule,
	User: UserModule,
	Team: TeamModule,
	Department: DepartmentModule,
	Coupon: CouponModule,
	Member: MemberModule,
	PO: POModule,
	PlatformStatement: PlatformStatementModule
}

export default new Vuex.Store({
  modules,
  plugins: [createPersistedState({
	paths: ['Auth'],
  })]
})
